"use strict";

/**
 * Wrap the listener functions so that all its functions are called from inside enterFunction
 * @param enterFunction
 * @returns {Function} - which takes a listener object, whose functions will be called from inside the enter function
 */
export const enterFunction =  (enterFunction) => {
    return function (listener) {
        if (!enterFunction) {
            return listener;
        }

        var createWrapper = function (f) {
            return function () {
                var This = this;
                var args = arguments;
                enterFunction(function () {
                    f.apply(This, args);
                });
            };
        };

        //If listener is a function, just wrap the function
        if (typeof listener == "function") {
            return createWrapper(listener);
        }

        //Make ret look like `listener`
        var ret = Object.create(listener);

        //...but make sure enterFunction is called before calling any functions
        Object.keys(listener).forEach(function (key) {
            var func = listener[key];
            if (typeof func != "function") {
                return;
            }

            ret[key] = createWrapper(func);
        });

        return ret;
    };
};